<template>
<!--    <div>-->
<!--        <h5>Otevírací doba <wbr/>od 6. března</h5>-->
    <table :class="['table','my-border', this.small && 'table-sm', this.stripped && 'table-striped']">
<!--        <thead><tr><th colspan="2">Otevírací doba od 6. března</th></tr></thead>-->
        <thead><tr><th colspan="2">Otevírací doba od Srpna</th></tr></thead>
        <tbody>
        <tr v-for="time in times_loaded" v-bind:key="time.day">
            <th scope="row" maxWidth="80">{{time.day}}</th>
            <td scope="row" style="text-align: left">{{time.time}}</td>
        </tr>
        </tbody>
    </table>
<!--    </div>-->
</template>

<script>
    export default {
        props: {
            times: {required: false},
            small: {required: false},
            stripped: {required: false},
        },
        methods:{
            getData: function () {
                let vm = this;
                // eslint-disable-next-line no-undef
                axios.get('/opening_time.json')
                    .then(function (response) {
                        // eslint-disable-next-line no-undef
                        vm.times_loaded = response.data;
                    })
                    .catch(function (error) {
                        console.error('Times load error' + error.status);
                    })
            }
        },
        data: function () {
                return {
                    times_loaded: []
                }
        },
        beforeMount(){
            this.getData();
            // console.log(this.times_loaded);
            if(this.times_loaded===undefined || Object.keys(this.times_loaded).length === 0){
                this.times_loaded = this.times;
            }
        },
    }
</script>
<style>
    .my-border {
        border: 0 solid #dee2e6;
        border-top-width: 1px;
    }
</style>